<template>
  <li class="mn" :class="{ 'mn--drag': ed.dragId === item.id }">
    <div
      class="mn-card"
      :class="dropClass"
      @dragover.prevent="onOver"
      @dragleave="drop = ''"
      @drop.prevent="onDrop"
    >
      <span
        class="mn-handle"
        draggable="true"
        title="برای جابه‌جایی بکشید"
        @dragstart="onStart"
        @dragend="ed.dragEnd()"
      >⋮⋮</span>
      <button type="button" class="mn-title" @click="item._open = !item._open">
        <b>{{ item.title || '(بدون عنوان)' }}</b>
        <small v-if="depth" class="mn-sub">زیرمنو</small>
        <small v-else class="mn-type">{{ typeLabel }}</small>
      </button>
      <span class="mn-tools">
        <button type="button" title="بالا" :disabled="index === 0" @click="ed.move(item, -1)">▲</button>
        <button type="button" title="پایین" :disabled="index === siblings.length - 1" @click="ed.move(item, 1)">▼</button>
        <button type="button" title="زیرمنوی آیتم قبلی" :disabled="index === 0" @click="ed.indent(item)">⇠</button>
        <button type="button" title="خروج از زیرمنو" :disabled="!depth" @click="ed.outdent(item)">⇢</button>
        <button type="button" class="mn-toggle" :aria-expanded="item._open ? 'true' : 'false'" @click="item._open = !item._open">{{ item._open ? '▴' : '▾' }}</button>
      </span>
    </div>

    <div v-if="item._open" class="mn-edit">
      <div class="form-row">
        <div class="col-md-6 form-group">
          <label>عنوان</label>
          <input v-model="item.title" class="form-control" @input="item._dirty = true">
        </div>
        <div class="col-md-6 form-group">
          <label>لینک</label>
          <input v-model="item.url" dir="ltr" class="form-control" placeholder="/shop/cat/..." @input="item._dirty = true">
        </div>
        <div v-if="!depth" class="col-md-6 form-group">
          <label>نوع نمایش</label>
          <select v-model.number="item.type" class="form-control" @change="item._dirty = true">
            <option :value="1">معمولی</option>
            <option :value="2">کشویی</option>
            <option :value="3">مگامنو</option>
          </select>
        </div>
        <div class="col-md-6 form-group">
          <label>آیکون</label>
          <CIconSelector v-model="item.icon" @input="item._dirty = true" />
        </div>
        <div class="col-12 form-group mb-2">
          <label class="mn-check">
            <input type="checkbox" :checked="item.target === '_blank'" @change="item.target = $event.target.checked ? '_blank' : ''; item._dirty = true">
            باز شدن در زبانه جدید
          </label>
        </div>
      </div>
      <div class="mn-edit-foot">
        <button type="button" class="btn btn-link text-danger p-0" @click="ed.remove(item)">حذف</button>
        <span class="text-muted">|</span>
        <button type="button" class="btn btn-link p-0" @click="item._open = false">بستن</button>
        <small v-if="item._dirty" class="mr-auto text-warning">تغییرات ذخیره نشده</small>
      </div>
    </div>

    <ul v-if="item.children.length || ed.dragId" class="mn-list mn-children" @dragover.prevent @drop.prevent.self="ed.dropInto(item)">
      <MenuNode v-for="(c, i) in item.children" :key="c.id" :item="c" :index="i" :siblings="item.children" :depth="depth + 1" />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'MenuNode',
  inject: ['ed'],
  props: {
    item: { type: Object, required: true },
    index: { type: Number, default: 0 },
    siblings: { type: Array, required: true },
    depth: { type: Number, default: 0 }
  },
  data() {
    return { drop: '' }
  },
  computed: {
    typeLabel() { return ({ 1: 'معمولی', 2: 'کشویی', 3: 'مگامنو' })[this.item.type] || 'معمولی' },
    dropClass() { return this.drop ? 'mn-drop-' + this.drop : '' }
  },
  methods: {
    onStart(e) {
      this.ed.dragStart(this.item)
      try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(this.item.id)) } catch (err) { /* old browsers */ }
    },
    onOver(e) {
      if (!this.ed.dragId || this.ed.dragId === this.item.id) return
      const r = e.currentTarget.getBoundingClientRect()
      const y = (e.clientY - r.top) / r.height
      this.drop = y < 0.3 ? 'before' : y > 0.7 ? 'after' : 'inside'
    },
    onDrop() {
      const where = this.drop
      this.drop = ''
      if (where) this.ed.dropAt(this.item, where)
    }
  }
}
</script>
